export const berechneErmuedung = (
  traggliedQuerschnitt,
  NR,
  teilsicherheitsbeiwertFuerErmuedung,
  schwingungsObergrenze,
  schwingungsUntergrenze,
  teilsicherheitsbeiwertFuerErmuedungslastenDinEN1991
) => {
  let calc, power, Rk, firstCalc;

  if (NR < 5_000_000) {
    power = Math.pow(70, 3);
    calc = Math.cbrt((power * 2_000_000) / NR);
    Rk = (traggliedQuerschnitt * calc) / 1_000;
  } else {
    power = Math.pow(51.6, 5);
    firstCalc = (power * 5_000_000) / NR;
    calc = Math.pow(firstCalc, 1 / 5);
    Rk = (traggliedQuerschnitt * calc) / 1_000;
  }

  let Rd = berechneRd(Rk, teilsicherheitsbeiwertFuerErmuedung);

  let upperLower = berechneUpperLower(
    schwingungsObergrenze,
    schwingungsUntergrenze,
    teilsicherheitsbeiwertFuerErmuedungslastenDinEN1991
  );

  let ausnutzungCalc = berechneAusnutztung(
    schwingungsObergrenze,
    schwingungsUntergrenze,
    teilsicherheitsbeiwertFuerErmuedungslastenDinEN1991,
    Rd
  );

  return { calc, Rk, Rd, upperLower, ausnutzungCalc };
};

export const berechneAusnutztung = (obergrenze, untergrenze, yf, Rd) => {
  if (untergrenze > obergrenze) return 0;

  return ((obergrenze - untergrenze) * yf) / Rd;
};

export const berechneRd = (Rk, teilsicherheitsbeiwertFuerErmuedung) => {
  return Rk / teilsicherheitsbeiwertFuerErmuedung;
};

export const berechneUpperLower = (obergrenze, untergrenze, yf) => {
  return (obergrenze - untergrenze) * yf;
};
